import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetStatus } from '../../../../state';
import { useGetAssetStatusesQuery } from '../../../../../../services/DimensionService/dimensionApi';

const StatusEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);
  const { data: statuses = [] } = useGetAssetStatusesQuery();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetStatus({ status: event.target.value }));
  };

  return (
    <TextField
      label="Status"
      size="small"
      required
      select
      fullWidth
      value={currentAsset?.status || ''}
      onChange={handleChange}
    >
      <MenuItem value="">
        <em>Select Status</em>
      </MenuItem>
      {statuses.map((s) => (
        <MenuItem key={s.value} value={s.value}>
          {s.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default StatusEdit;
